/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { QuestionCircleIcon16Light } from './QuestionCircleIcon16Light';
import { QuestionCircleIcon16Regular } from './QuestionCircleIcon16Regular';
import { QuestionCircleIcon16Solid } from './QuestionCircleIcon16Solid';
import { QuestionCircleIcon20Light } from './QuestionCircleIcon20Light';
import { QuestionCircleIcon20Regular } from './QuestionCircleIcon20Regular';
import { QuestionCircleIcon20Solid } from './QuestionCircleIcon20Solid';
import { QuestionCircleIcon24Regular } from './QuestionCircleIcon24Regular';
import { QuestionCircleIcon24Solid } from './QuestionCircleIcon24Solid';
import { QuestionCircleIcon32Regular } from './QuestionCircleIcon32Regular';
import { QuestionCircleIcon64Regular } from './QuestionCircleIcon64Regular';
var sizes = {
    16: {
        light: QuestionCircleIcon16Light,
        regular: QuestionCircleIcon16Regular,
        solid: QuestionCircleIcon16Solid,
    },
    20: {
        light: QuestionCircleIcon20Light,
        regular: QuestionCircleIcon20Regular,
        solid: QuestionCircleIcon20Solid,
    },
    24: {
        regular: QuestionCircleIcon24Regular,
        solid: QuestionCircleIcon24Solid,
    },
    32: {
        regular: QuestionCircleIcon32Regular,
    },
    64: {
        regular: QuestionCircleIcon64Regular,
    },
};
export var QuestionCircleIcon = forwardRef('QuestionCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
